import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { TagType } from './tag-type.interface';
import tagTypeService from './tag-type.service';

export interface TagTypeState {
   tagTypes: Array<TagType>;
}

const TagTypeStore: Module<TagTypeState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async postBulk(context, body) {
         return await tagTypeService.postBulk(body).then((response) => {
            context.commit('board/linkTagType', response, { root: true });
            return response;
         });
      },
      async patch(context, { tag_type_id, path, value }: { tag_type_id: number; path: string; value: any }) {
         const BODY = { op: 'replace', path: path, value: value };
         return await tagTypeService.patch(tag_type_id, BODY).then((response) => {
            context.commit('pool/patchTagTypeInPool', { tag_type_id, path, value }, { root: true });
            return response;
         });
      },
      async putBulk(context, { tag_type_id, body }: { tag_type_id: number; body: any }) {
         return await tagTypeService.putBulk(tag_type_id, body).then((response) => {
            context.commit('pool/UPDATE_TAG_TYPE', response, { root: true });
            context.commit('board/UPDATE_TAG_TYPE', response, { root: true });
            return response;
         });
      },
      async delete(context, { tag_type_id }: { tag_type_id: number }) {
         return await tagTypeService.delete(tag_type_id).then((response) => {
            context.commit('board/removeTagTypeFromBoard', tag_type_id, { root: true });
            return response;
         });
      },
   },
};

export default TagTypeStore;
